"use strict";

angular
	.module('rmEPG', []);

require('./controller');
require('./resources');
require('./directives');
require('./filters');
require('./routes');
require('./factories');
